import {
    ADMIN_LEVEL_ACCESS,
    DEVELOPER_LEVEL_ACCESS,
    GROUP_LEVEL_ACCESS,
    USER_LEVEL_ACCESS,
} from 'src/components/access';
import type { TFiltersOptions, UserForFilters } from './types';

/**
 * Returns initial filter options (e.g. store list) based on the current user's access level.
 * Developer: no store restriction. Admin/User: user's stores. Group: group's stores.
 *
 * @param user - Current user with accessLevel, stores, and optional group.stores
 * @returns TFiltersOptions with success and optional store list, or null if no access level
 */
export function getInitialFiltersByAccessLevel(
    user: UserForFilters
): TFiltersOptions | null {
    if (!user?.accessLevel) return null;
    if (user.accessLevel === DEVELOPER_LEVEL_ACCESS) return { success: true };
    if (
        user.accessLevel === ADMIN_LEVEL_ACCESS ||
        user.accessLevel === USER_LEVEL_ACCESS
    ) {
        const store = (user?.stores || []).map((s) => ({
            label: s.name,
            value: s._id,
        }));
        return { success: true, store };
    }
    if (user.accessLevel === GROUP_LEVEL_ACCESS) {
        const store = (user?.group?.stores || []).map((s) => ({
            label: s.name,
            value: s._id,
        }));
        return { success: true, store };
    }
    return null;
}
